import { render, staticRenderFns } from "./autograph.vue?vue&type=template&id=375de14e&scoped=true&"
import script from "./autograph.vue?vue&type=script&lang=js&"
export * from "./autograph.vue?vue&type=script&lang=js&"
import style0 from "./autograph.vue?vue&type=style&index=0&id=375de14e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375de14e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('375de14e')) {
      api.createRecord('375de14e', component.options)
    } else {
      api.reload('375de14e', component.options)
    }
    module.hot.accept("./autograph.vue?vue&type=template&id=375de14e&scoped=true&", function () {
      api.rerender('375de14e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sellgold/components/autograph.vue"
export default component.exports